import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import OImageUpload from 'components/commons/OImageUpload';
import OTextField from 'components/commons/OTextField';
import OTextArea from 'components/commons/OTextArea';
import { translate } from 'react-i18next';
class BasicInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            persona: props.persona,
        };
    }
    
    componentWillReceiveProps(nextProps) {
        this.setState({ persona: nextProps.persona });
    }

    render() {
    	const {t} = this.props;
        return (
        	<Row>
	            <Col md={6}>
		            <Col md={12}>
		                <OTextArea container={this.state.persona} fieldName="coreProblems.goals" label={t('assumption.basicInfo.goals')}/>
		            </Col>
		            <Col md={12}>
		                <OTextArea container={this.state.persona} fieldName="coreProblems.values" label={t('assumption.basicInfo.values')}/>
		            </Col>
	            </Col>
	            <Col md={6}>
		            <Col md={12}>
		                <OTextArea container={this.state.persona} fieldName="coreProblems.challenges" label={t('assumption.basicInfo.challenges')}/>
		            </Col>
		            <Col md={12}>
		                <Row>
		                	<h3>{t('assumption.basicInfo.painPoints')}</h3>
		                </Row>
		                <Row>
		                    <Col md={12}>
		                         <OTextField prefix="1. " container={this.state.persona} fieldName="coreProblems.painPoints.0" size="small" placeholder="Problem..." />
		                    </Col>
		                    <Col md={12}>
		                         <OTextField prefix="2. " container={this.state.persona} fieldName="coreProblems.painPoints.1" size="small" placeholder="Problem..." />
		                    </Col>
		                    <Col md={12}>
		                         <OTextField prefix="3. " container={this.state.persona} fieldName="coreProblems.painPoints.2" size="small" placeholder="Problem..." />
		                    </Col>
		                </Row>
		            </Col>
	            </Col>
        	</Row>
        );
    }

    onUpdate(persona) {
        if (this.props.onUpdate) {
            this.props.onUpdate(persona);
        }
        this.setState({ persona });
    }

    updatePhoto(persona) {
        this.personaCrudService.updatePhoto(persona.id, persona.avatar);
        this.onUpdate(persona);
    }
}

export default translate('translations')(BasicInfo);


// WEBPACK FOOTER //
// ./src/components/assumptions/profiles/PainPointsForm.js